import Styled from 'styled-components'

export default Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
`



// WEBPACK FOOTER //
// ./src/components/DialogDescription/index.js